import rxios from '../common/rxios'
import { map } from 'rxjs/operators'

function currentDomain() {
  const hostname = document.location.hostname;
  const parts = hostname.split('.')
  return parts.splice(parts.length - 2).join(".");
}

let sessionOrigin = domain.homepage

// https://alpha-mc.toast.com/ 등의 도메인 변경이 되지 않아 삽입 한 코드
if(mode === "gnb" || mode === "pc-gnb") {
  if(currentDomain() === 'toast.com') {
    sessionOrigin = domain.toast
  }
}

export const sessionService = {
  getSession$() {
    return rxios
    .get(`${sessionOrigin}/homepage/v1/sessions`, {
      withCredentials: true
    })
    .pipe(map(response => response.data))
  }
}
